<style src="./GroupHeader.scss"lang="scss"></style>
<template>
  <tr class="group-header">
    <th scope="row" class="header id"></th>
    <th class="header" colspan="6"></th>

    <!-- COST -->
    <th
      @click="toggleColumnView('costLab', 'costUnit', 'costTotal')"
      class="header group"
      colspan="3">
      <span class="title">CUSTO</span>
    </th>

    <!-- MAX PRICE -->
    <th
      @click="toggleColumnView('maxLab', 'maxUnit', 'maxTotal')"
      class="header group"
      colspan="4">
      <span class="title">CMED</span>
    </th>

    <!-- ESTIMATED -->
    <th
      @click="toggleColumnView('estimatedUnit', 'estimatedTotal')"
      class="header group"
      colspan="3">
      <span class="title">ESTIMADO</span>
    </th>

    <!-- PROPOSAL -->
    <th
      @click="toggleColumnView('proposalUnit', 'proposalTotal')"
      class="header group"
      colspan="3">
      <span class="title">VENDA</span>
    </th>

    <!-- MINIMUM -->
    <th
      @click="toggleColumnView('minimumUnit', 'minimumTotal')"
      class="header group"
      colspan="3">
      <span class="title">MÍNIMO</span>
    </th>

    <!-- DYNAMIC -->
    <th
      v-for="( groups, groupsIdx) in getDynamicGroups"
      :key="groupsIdx"
      class="header group"
      :colspan="groups.colSpan">
      <div class="groupbar">
        <input
          v-if="columnData.columnInEditModel === groupsIdx"
          class="cp1-small-textbox"
          v-model="columnData.newTitle"
          @keydown.enter="saveTitle(groups, groupsIdx)"
          @keydown.esc="cancelEditTitle"
          type="text">
        <span
          v-show="columnData.columnInEditModel !== groupsIdx"
          @dblclick="enterEditTitle(groupsIdx, groups.groupName)"
          class="title distributor">
          {{ groups.groupName }}
        </span>
        
        <div class="filtered">
          <div
            class="optionalmenu"
            @click.stop="toggleContextDynmaicPopup(groupsIdx)">
            <icon-dotted-menu class="dottedmenu" />
          </div>
          
          <context-popup
            @close="toggleContextDynmaicPopup(groupsIdx, false)"
            v-if="visibleContextMenu.dynamicColumn===groupsIdx"
            position="left">
            <context-group-remove
              :group="groups" />
          </context-popup>
        </div>
      </div>
    </th>
  </tr>
</template>

<script>
import { mapGetters } from 'vuex'
import { IconAdd, IconDottedMenu } from '@/components/primitives/icons'
import { ContextPopup } from '@/components/primitives'
import ContextGroupRemove from '../context-group-remove/ContextGroupRemove.vue'

export default {
  name: 'GroupHeader',
  components: {
    IconAdd,
    IconDottedMenu,
    ContextPopup,
    ContextGroupRemove
  },
  computed: {
    ...mapGetters({
      getDynamicGroups: 'ItemPricing/GET_DYNAMIC_GROUPS'
    })
  },
  data: () => ({
    visibleContextMenu: {
      dynamicColumn: null
    },
    columnData: {
      columnInEditModel: null,
      oldTitle: '',
      newTitle: 'teste'
    }
  }),
  methods: {
    toggleColumnView (...columns) {
      this.$emit('toggle-column', columns)
    },
    toggleContextDynmaicPopup (dynamicColumnsIdx) {
      if (this.visibleContextMenu.dynamicColumn === dynamicColumnsIdx) {
        this.visibleContextMenu.dynamicColumn = null
      } else {
        this.visibleContextMenu.dynamicColumn = dynamicColumnsIdx
      }
    },
    enterEditTitle (groupIdx, title) {
      this.columnData.oldTitle = title
      this.columnData.newTitle = title
      this.columnData.columnInEditModel = groupIdx
    },
    cancelEditTitle () {
      this.columnData.newTitle = this.columnData.oldTitle
      this.columnData.columnInEditModel = null
    },
    async saveTitle (groups, groupsIdx) {
      try {
        const payload = {
          groupIdx: groupsIdx,
          groupId: groups.groupId,
          newTitle: this.columnData.newTitle
        }
        await this.$store.dispatch('ItemPricing/UPDATE_DYNAMIC_GROUP_TITLE', payload)
        this.columnData.columnInEditModel = null
      } catch (error) {
        this.columnData.columnInEditModel = null
        this.columnData.oldTitle = ''
        this.columnData.newTitle = ''
        console.error(error)
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/view/item-pricing/components/group-header/GroupHeader.vue